<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>车辆押金列表</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->
    <!-- 卡片 -->
    <el-card class="box-card" >
      <!-- 搜索  新增-->
      <el-form
          :model="searchForm"
          ref="searchForRef"
          label-width="80px"
          >
        <el-row :gutter="24">
          <el-col :span="7">
            <el-form-item label="车牌号 | 所属人" size="small" label-width="120px">
              <el-input v-model="searchForm.queryParams" placeholder="请输入车牌号" clearable type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="开始时间" size="small" label-width="70px">
              <el-date-picker v-model="searchForm.start_time" type="date"  placeholder="请选择开始时间" style="width: 80%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结束时间" size="small" label-width="70px">
              <el-date-picker v-model="searchForm.end_time" type="date"  placeholder="请选择结束时间" style="width: 80%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
          </el-col>
          <el-col :span="1">
            <el-button size="small" type="primary" @click="addData">新增</el-button>
          </el-col>
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          height="450" :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
      >
        <el-table-column
            label="ID"
            min-width="10%"
            type="index"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="日期"
            min-width="20%"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">{{ scope.row.add_time | dateFormat }}</template>
        </el-table-column>
        <el-table-column
            label="经办人"
            min-width="20%"
            prop="op_name"
            :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
            label="车牌"
            min-width="20%"
            prop="plate_number"
            :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
            label="车主"
            min-width="25%"
            prop="allPerson"
            :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column label="金额" min-width="15%" prop="fee" :show-overflow-tooltip='true'></el-table-column>

        <el-table-column
            label="操作"

            min-width="20%">
          <template slot-scope="scope">
            <el-button type="warning" size="small" icon="el-icon-edit" @click="handelEdit(scope.row)"></el-button>
            <el-button type="danger" size="small" icon="el-icon-delete" @click="handelDel(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="70%">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="收款状态" size="small">
              <el-select v-model="form.receive_status" placeholder="请选择状态">
                <el-option label="已收款" :value="1"></el-option>
                <el-option label="未收款" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收款日期"  size="small">
              <el-date-picker v-model="form.receive_time" type="date"  placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <carListTemp ref="carListTemp" @changeData="setcarInfo"></carListTemp>
          </el-col>
          <!--
          <el-col :span="12">
            <shopCompanyTemp ref="shopCompanyTemp"></shopCompanyTemp>
          </el-col>-->
        </el-row>

        <el-row :gutter="24">
          <el-col :span="6" >
            <el-form-item label="车主"  size="small">
              <el-input v-model="form.allPerson" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="6">
            <el-form-item label="金额" prop="fee" size="small">
              <el-input v-model="form.fee" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="图片" :visible.sync="uploadDialog" width="300px" style="line-height: 0;">
      <img style="width: 100%;height: 100%" :src="uploadImg" alt="" />
    </el-dialog>
    <!--
        <eCar :carVisibleProp="isShowCar" v-on:eventCar="chooseCarInfo()"/>
    -->
  </div>
</template>

<script>
import eTable from "../common/eTable.vue";
import moment from 'moment';    //日期时间转换
import eCar from "../common/eCar";
import shopCompanyTemp from "../common/shopCompanyTemp.vue";
import carListTemp from "../common/carlistTemp.vue";
export default {
  name: "shipCompany",
  components: {
    eTable,
    eCar,
    shopCompanyTemp,
    carListTemp
  },
  props: {},
  data() {
    return {
      isShowCar:false,
      // 搜索
      searchForm: {
        queryParams:'',
        start_time:'',
        end_time:''
      },
      searchRules: {
      },
      // 数据
      tableLoadData: [],
      limit: 10,
      page:1,// 当前页码
      total:0,//总条目数
      id: '',
      rules: {
        car_id: [{ required: true, message: '请选择车辆', trigger: 'blur' }],
        shop_id: [{ required: true, message: '选择运输公司', trigger: 'blur' }],
        allPerson: [{ required: true, message: '请输入车主', trigger: 'blur' }],
        receive_status:[{required: true, message: '请选择收款状态', trigger: 'blur' }],
        plate_number:[{required: true, message: '请输入车牌', trigger: 'blur' }],
        fee:[{required: true, message: '请输入费用', trigger: 'blur' },
             {pattern:'([1-9]\\d*(\\.\\d*[1-9])?)|(0\\.\\d*[1-9])',message: '费用必须大于0',trigger: 'blur'}
        ],
      },
      dialogFormVisible: false,
      title: '',
      form: {
        receive_time:'',//收款时间
        refund_time:'',  //退款时间
        op_name:'',  //经办人
        plate_number:'', //车牌
        allPerson:'', //车主
        fee:'', //费用
        receive_status:'', //收款状态
        refund_status:'', //退款状态
        shop_id:'', //运输公司id
        car_id: '', //车辆ID
      },
      uploadImg: '',
      uploadDialog: false
    };
  },
  created() {
    this.DataList()
  },
  mounted() {

  },
  filters: {
    statusFilter(status) {
      if (status == 1) {
        return "启用";
      } else if (status == 2) {
        return "禁用";
      }
    },
    //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },

  },
  methods: {
    setcarInfo(value){
      this.$set(this.form,'allPerson' , value.allPerson) //不用set 的形式，页面数据不更新
      //this.form.vin = value.vin
      //this.form.model = value.model
     // this.form.issue_date = value.issue_date
     // this.form.register_date = value.register_date
    },
    chooseCar(){
      this.isShowCar=true;
      //console.log('dddd',this.isShowCar)
    },
    //接收子组件传过来的值
    chooseCarInfo(car_number,...params){
      this.searchForm.queryParams=car_number;
    },
    DataList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        page: this.page,
        pageSize:this.limit
      }
      if(this.searchForm.queryParams) param.queryParams = this.searchForm.queryParams
      if(this.searchForm.start_time) param.start_time =  this.getTime(this.searchForm.start_time)
      if(this.searchForm.end_time) param.end_time = this.getTime(this.searchForm.end_time)
      this.$axios.getDepositList(param).then(res=>{
        if(res.code == 200){
          this.tableLoadData = res.data.data
          this.total = res.data.total
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.limit = newSize
      this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.page = newPage
      this.DataList()
    },
    // 新增
    addData() {
      this.title = '新增'
      this.form = {
        // role_name: '',
      }
      this.dialogFormVisible = true
    },
    handelEdit(index,row) {
      this.id = index.id

      this.title = '编辑'
      this.form = {
      }
      this.dialogFormVisible = true
      // this.form = {...row};
      // 或者
      this.form = JSON.parse(JSON.stringify(index))
    },

    reset_dialogForm(formName) {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const param = {
            receive_time:this.form.receive_time,//收款时间
            refund_time:this.form.refund_time,  //退款时间
            op_name:this.form.op_name,  //经办人
            plate_number:this.form.plate_number, //车牌
            allPerson:this.form.allPerson, //车主
            fee:this.form.fee, //费用
            receive_status:this.form.receive_status, //收款状态
            refund_status:this.form.refund_status, //退款状态
            car_id: this.$refs.carListTemp.form.car_id,//this.form.car_id,
            //shop_id: this.$refs.shopCompanyTemp.searchForm.shop_id,//this.form.shop_id,
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token')
          }
          if(this.id) param.id = this.id
          this.$axios.saveDeposit(param).then(res =>{
            if(res.code == 200){
              this.DataList()
              this.$message.success(res.msg)
              this.dialogFormVisible = false
            }else{
              this.$message.error(res.msg);
            }
          })
        }
      })
    },
    searchSubmit() {
      this.page = 1
      this.DataList()
    },

    handelDel(e) {
      this.$confirm('此操作将删除车辆押金信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          id: e.id,
        }
        //console.log(param);
        this.$axios.delDepositList(param).then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg);
            this.DataList()
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      }).catch(() => {
        // 点击取消:不删除了
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
        this.DataList()
      });
      this.teamDialog = false
    },
  },
};
</script>
<style>
.table_name{
  font-weight: bold;
  /* border: 1px solid #f00; */
}
.table_name:hover{
  color: #409EFF;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/car/depositList.vue